<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'

const { showModal, goToHome } = useGlobalErrorModal()
</script>

<template>
  <UIDialog
    v-model="showModal"
    size="md"
    :hide-close-button="true"
    :hide-title="true"
  >
    <div class="pt-5 pb-0 text-center">
      <div class="flex justify-center mb-2">
        <ExclamationTriangleIcon
          class="w-[28px] h-[28px]"
          style="color: #cc413d"
        />
      </div>
      <h2 class="text-xl font-bold text-gray-900 mb-2">An error occurred</h2>
      <div class="mb-2">
        <p
          class="text-[16px] font-normal leading-tight mb-0.5"
          style="color: #343434"
        >
          We're in the dog house. Something went wrong.
        </p>
        <p
          class="text-[16px] font-normal leading-tight"
          style="color: #343434"
        >
          Please
          <a
            href="/help"
            class="underline text-primary hover:text-primary/80"
          >
            contact us
          </a>
          for help.
        </p>
      </div>
    </div>
    <template #actions>
      <Button
        color="primary"
        class="px-[85px] py-2 mb-5 mt-0"
        @click="goToHome"
      >
        Back to home
      </Button>
    </template>
  </UIDialog>
</template>
